// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-772377de] {\n  fill: #fff\n}\n.st20[data-v-772377de] {\n  fill: #9fdde0\n}\n.st22[data-v-772377de] {\n  fill: #7fd2d5\n}\n", ""]);
// Exports
module.exports = exports;
